import API from '@/services/api/api'
import axios from 'axios'

export default async payload => {
    try {
        const route = API.BLOCK_UNBLOCK_SL_CUSTOMER
        let data = {
            blocked_sales: payload.blocked_sales,
            sl_customer_id: payload.sl_customer_id,
        }
        let response = await axios.post(route, data)
        return response
    } catch (error) {
        return error.response.data
    }
}
